// extracted by mini-css-extract-plugin
export default {"text":"result_text__HQFhF"};